import VueI18n from 'vue-i18n';
import { Route } from 'vue-router';
import { Routes } from '@front-app/constants/routes';
import { PhoenixRouteConfig } from '@front-app/router/Model';

export const learning: PhoenixRouteConfig[] = [
	{
		meta: {
			title(i18n: VueI18n): string {
				return i18n.t('group.tabs.learning') as string;
			},
		},
		path: 'learning',
		name: Routes.GROUP_LEARNING,
		redirect: { name: Routes.GROUP_LEARNING_PROGRAMS_LIST },
		component: () => import(/* webpackChunkName: "group_lms" */ '@front-app/views/home/group/GroupLearning.vue'),
		children: [
			{
				meta: {
					title(i18n: VueI18n): string {
						return i18n.t('group.tabs.learning') as string;
					},
				},
				path: 'programs',
				name: Routes.GROUP_LEARNING_PROGRAMS_LIST,
				component: () => import(/* webpackChunkName: "group_lms" */ '@front-app/views/home/group/learning/ProgramList.vue'),
				// eslint-disable-next-line @typescript-eslint/no-explicit-any
				props(route: Route): any {
					return {
						programId: route.params.programId,
					};
				},
			},
			{
				meta: {
					title(i18n: VueI18n): string {
						return i18n.t('group.tabs.learning') as string;
					},
				},
				path: 'programs/:programId',
				name: Routes.GROUP_LEARNING_PROGRAM,
				component: () => import(/* webpackChunkName: "group_lms" */ '@front-app/views/home/group/learning/ProgramSingle.vue'),
				// eslint-disable-next-line @typescript-eslint/no-explicit-any
				props(route: Route): any {
					return {
						programId: route.params.programId,
					};
				},
			},
			{
				meta: {
					title(i18n: VueI18n): string {
						return i18n.t('group.tabs.learning') as string;
					},
				},
				path: 'programs/:programId/module/:moduleId',
				name: Routes.GROUP_LEARNING_MODULE,
				component: () => import(/* webpackChunkName: "group_lms" */ '@front-app/views/home/group/learning/ModuleSingle.vue'),
				// eslint-disable-next-line @typescript-eslint/no-explicit-any
				props(route: Route): any {
					return {
						programId: route.params.programId,
						moduleId: route.params.moduleId,
					};
				},
			},
		],
	},
];
